import React from 'react'
import addToMailchimp from 'gatsby-plugin-mailchimp'

export default class NewsletterSignup extends React.Component {
    state = {
        name: null,
        email: null,
    }

    _handleChange = e => {
        // console.log({
        //     [`${e.target.name}`]: e.target.value,
        // })
        this.setState({
            [`${e.target.name}`]: e.target.value,
        })
    }

    _handleSubmit = e => {
        e.preventDefault()

        // console.log('submit', this.state)

        addToMailchimp(this.state.email, this.state)
            .then(({ msg, result }) => {
                console.log('msg', `${result}: ${msg}`)

                if (result !== 'success') {
                    // throw msg
                    document.getElementById('newsletter-signup--pre').innerHTML = msg
                }
                else {
                  document.getElementById('newsletter-signup--pre').style.display = 'none'
                  document.getElementById('newsletter-signup--post').style.display = 'block'
                  document.getElementById('submit-label').innerHTML = 'Thanks'
                  document.getElementById('submit-button').className += ' hide-input'
                  document.getElementById('submit-button').className += ' thanks'
                  document.getElementById('email-input').className += ' hide-input'
                }
                // alert(msg)
            })
            .catch(err => {
                // console.log('err', err)
                // alert(err)
            })
    }

    render() {
        return (
            <div class="newsletter-signup">
              <p class="newsletter-signup--pre" id="newsletter-signup--pre">Stay in the loop. Sign up now!</p>
              <p class="newsletter-signup--post" id="newsletter-signup--post">Thanks for signing up, we'll be in touch with all the latest news from the world of SHIFT!</p>
              <form onSubmit={this._handleSubmit}>
                <input type="email" name="email" id="email-input" onChange={this._handleChange} required placeholder="Your email address" />
                <button type="submit" id="submit-button">Submit</button>
              </form>
            </div>
        )
    }
}